import React, { ReactNode } from 'react';
import dayjs from 'dayjs';
import { ApiPackageModel } from '@ibe/api';
import { ConfigModel } from '@ibe/services';
import isBetween from 'dayjs/plugin/isBetween';
import { HighlightDatesInformation } from '../DateRangeInput/DateRangeInput';

dayjs.extend(isBetween);

const renderDayContents = (
  config: ConfigModel,
  availabilityPackage?: ApiPackageModel,
  includeDates?: Date[],
  highlightDatesInformation?: HighlightDatesInformation,
  withColorCodedAvailability?: boolean
): ((dayOfMonth: number, fullDate?: Date) => ReactNode) => (
  dayOfMonth: number,
  fullDate?: Date
): ReactNode => {
  let availabilityClassName = '';
  const isWithOfferHighlightIcon = highlightDatesInformation?.dateRanges?.some(dateRange => {
    return dayjs(fullDate).isBetween(
      dayjs(dateRange?.startDate),
      dayjs(dateRange?.endDate),
      'day',
      '[]'
    );
  });

  if (withColorCodedAvailability) {
    availabilityClassName = 'customDayContents';

    const relatedPackageDetail = availabilityPackage?.packageDetails?.find(packageDetail =>
      dayjs(packageDetail.startDate).isSame(dayjs(fullDate))
    );

    const threshold = config.availabilityCalendarThreshold;

    if (relatedPackageDetail && threshold) {
      const dateAvailability = relatedPackageDetail.totalAvailability;

      if (dateAvailability) {
        if (
          !(
            fullDate &&
            includeDates &&
            !includeDates.some(val => val.getTime() === fullDate.getTime())
          )
        ) {
          if (dateAvailability > threshold) {
            availabilityClassName = 'customDayContents_available';
          } else if (dateAvailability <= threshold && dateAvailability > 0) {
            availabilityClassName = 'customDayContents_busy';
          } else if (dateAvailability == 0) {
            availabilityClassName = 'customDayContents_unavailable';
          }
        }
      }
    }
  }

  return (
    <span className={availabilityClassName}>
      <span className="offer-highlight-day">{dayOfMonth}</span>
      {isWithOfferHighlightIcon ? (
        <span className="offer-highlight-icon">{highlightDatesInformation?.highlightIcon}</span>
      ) : null}
    </span>
  );
};

export default renderDayContents;
